export const titular = [
    {
        "nombre" : "Vanesa Escalante Arroyo",
        "imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/gabinete/VanesaEscalanteArroyo.jpg",
        "funcion" : "La Persona Titular de la Secretaría determinará la organización y funcionamiento de la Secretaría, la adscripción de sus unidades administrativas y órganos desconcentrados, así como la modificación de las áreas, sus atribuciones y facultades, en la medida que lo requiera el servicio y de conformidad con la normatividad aplicable y el presupuesto correspondiente."
    }
]
